module.exports = __webpack_public_path__ + "img/img44.28c41796.png";